import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpClientService } from '../common/http-client.service';

import { DocumentType } from '../../models/document-type';

@Injectable()
export class DocumentTypeService {
  private documentTypesURL = 'document_types';

  constructor(private httpClient: HttpClientService) {}

  delete(id: number): Promise<any> {
    return this.httpClient.delete(`${this.documentTypesURL}/${id}.json`);
  }

  fetchTemplates(document_type_id: number, term: string, matter_type_id: number): Promise<any> {
    return this.httpClient.get(`${this.documentTypesURL}/${document_type_id}/fetch_templates.json`, { term: term, matter_type_id: matter_type_id, array: true });
  }

  getChildren(id: number, params: any = {}): Promise<any> {
    params.get_children = true;
    return this.httpClient.get(`${this.documentTypesURL}/${id}.json`, params);
  }

  get(id: number, params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.documentTypesURL}/${id}.json`, params);
  }

  index(params: any): Promise<any> {
    return this.httpClient.get(`${this.documentTypesURL}.json`, params);
  }

  tree(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.documentTypesURL}.json`, { ...params, get_tree: true });
  }

  indexObservable(params: any): Observable<any> {
    return this.httpClient.getObservable(`${this.documentTypesURL}.json`, params).pipe(map((response) => response as any));
  }

  save(documentType: DocumentType): Promise<any> {
    if (documentType.id) return this.httpClient.put(`${this.documentTypesURL}/${documentType.id}.json`, { document_type: documentType });
    else return this.httpClient.post(`${this.documentTypesURL}.json`, { document_type: documentType });
  }
}
